/* istanbul ignore file */

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Success = () => <CheckCircleIcon sx={{ color: '#ceecd8' }} />;

export default Success;
